import { Platform, StyleSheet } from 'react-native'
import type { ViewStyle } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import type { ThemeMode } from '../../../src/theme/ThemeContext'

export type PillButtonGroupVariant = 'social' | 'filter'

const INACTIVE_FILTER_BG_OPACITY = '22'
const INACTIVE_FILTER_BORDER_OPACITY = '45'

export const getPillButtonGroupStyles = (
  theme: Theme,
  variant: PillButtonGroupVariant,
  themeMode?: ThemeMode,
) => {
  const isLight = themeMode === 'light'

  return StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: Platform.OS === 'web' && variant === 'filter' ? 8 : 6,
    },
    pill:
      variant === 'social'
        ? {
            paddingVertical: 6,
            paddingHorizontal: 12,
            borderRadius: 20,
            backgroundColor: isLight ? theme.gray[100] : theme.gray[200],
            borderWidth: 1,
            borderColor: theme.gray[300],
          }
        : {
            paddingHorizontal: 12,
            paddingVertical: 6,
            borderRadius: 18,
            backgroundColor: theme.primary + INACTIVE_FILTER_BG_OPACITY,
            borderWidth: 1,
            borderColor: theme.primary + INACTIVE_FILTER_BORDER_OPACITY,
            justifyContent: 'center' as const,
            alignItems: 'center' as const,
          },
    pillActive:
      variant === 'social'
        ? isLight
          ? ({
              backgroundColor: 'rgba(255, 255, 255, 0.45)',
              borderColor: theme.gray[400],
            } as const)
          : { backgroundColor: theme.primary, borderColor: theme.primary }
        : { backgroundColor: theme.primary, borderColor: theme.primary },
    pillDisabled: {
      opacity: 0.5,
      ...(Platform.OS === 'web' && { cursor: 'not-allowed' as ViewStyle['cursor'] }),
    },
    pillPressed: { opacity: 0.85 },
    pillHover: { opacity: 0.9 },
    pillText:
      variant === 'social'
        ? {
            fontSize: 13,
            fontWeight: '600' as const,
            color: theme.gray[600],
          }
        : {
            fontSize: Platform.OS === 'web' ? 11 : 10,
            fontWeight: '600' as const,
            color: theme.gray[600],
            textAlign: 'center' as const,
          },
    pillTextActive:
      variant === 'social'
        ? {
            color: isLight ? theme.primary : theme.onPrimary,
            fontWeight: '600' as const,
          }
        : {
            fontSize: Platform.OS === 'web' ? 11 : 10,
            fontWeight: '700' as const,
            color: theme.onPrimary,
          },
    pillTextDisabled: {
      color: theme.gray[500],
    },
  })
}
